<template>
  <transition name="fade-in">
    <div class="functional-floating" v-show="show">
      <button
        class="functional-item"
        v-for="(icon, index) in floating"
        :key="index"
        @click="tap(icon.name)"
        >
        <img :src="icon.icon" alt="">
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'functionalFloating',
  data () {
    return {
      timer: null,
      show: true,
      floating: [
        {
          name: 'shopingTrolley',
          icon: require('../../assets/img/back-cart.png')
        },
        {
          name: false,
          icon: require('../../assets/img/back-top.png')
        },
        {
          name: 'home',
          icon: require('../../assets/img/go-home.png')
        }
      ]
    }
  },
  mounted () {
    window.addEventListener('scroll', this.scrollHandler, false)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollHandler, false)
  },
  methods: {
    tap (name) {
      if (!name) {
        window.scrollTo(0, 0)
      } else {
        this.$router.push({ name })
      }
    },
    scrollHandler (e) {
      if (this.show) {
        this.show = false
      }
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.show = true
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
.functional-floating {
  position: fixed;
  right: 0.2rem;
  bottom: 2rem;
  .flex-column;
  .functional-item {
    width: 0.81rem;
    height: 0.81rem;
    margin-bottom: 0.2rem;
  }
}
</style>
